/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const INTERVAL = feature.getSettingValue('INTERVAL');
    const NAME = `timer_${feature.getID()}`;
    const tickLinks = project.getNodeLinks(feature, 'timer_tick');

    let iterruptCode = '';

    if (tickLinks.length > 0) {
        const link = tickLinks[0];

        iterruptCode += `
    /****${link.getSourceId()}****/`;
    }

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
struct k_timer ${NAME};`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
extern void timer_interruption_handler_${NAME}(struct k_timer *timer_id);`,
    });

    blocks.push({
        location: 'FUNCTION_DEFINITIONS',
        blockType: BlockType.CODE,
        template: `
void timer_interruption_handler_${NAME}(struct k_timer *timer_id) {
    k_work_submit(&${NAME}_timer_tick_work);
}

void timer_tick_${NAME}_work_handler(struct k_work *work)
{
    ${iterruptCode}
}
`,
    });

    blocks.push({
        location: 'boot_complete',
        blockType: BlockType.CODE,
        template: `
k_timer_init(&${NAME}, timer_interruption_handler_${NAME}, NULL);
k_timer_start(&${NAME}, K_MSEC(${(Number(INTERVAL) * 1000).toString()}), K_MSEC(${(Number(INTERVAL) * 1000).toString()}));
`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
k_work_init(&${NAME}_timer_tick_work, timer_tick_${NAME}_work_handler);
`,
    });

    blocks.push({
        location: 'GLOBAL_TYPES',
        blockType: BlockType.CODE,
        template: `
struct k_work ${NAME}_timer_tick_work;`,
    });

    return blocks;
};
